
import Icon from "../components/icon";
import {Link} from 'react-router-dom';
import Logo from "../modules/generic/Logo";
import Scrollbar from 'perfect-scrollbar-react';
import 'perfect-scrollbar-react/dist/style.min.css';
import {UseUserInfo, IsSuperAdmin} from "../hooks/UseToken";


const Leftbar = ({items}) => {
    const UserInfo = UseUserInfo()

    return (
        <div className="Sidebar">
            <div className="SidebarBrand">
                <Logo/>
            </div>
            <Scrollbar>
                {

                    items.map((section) => {
                        const isVisible = section.role === UserInfo.role.slug || section.role === 'all' || IsSuperAdmin()
                        return (
                            <div key={section.section}>
                                {isVisible && <div className="menu-section-item">
                                    <strong className="title">{section.section}</strong>
                                    {section.childs.map((item) => {
                                        return <li key={item.label}>
                                            {item.path.includes('://')
                                                ? <a href={item.path} target="_blank" rel="noopener noreferrer"><Icon style={{ height: '16px'}} name={item.icon} /> {item.label}</a>
                                                : <Link to={item.path}><Icon style={{ height: '16px'}} name={item.icon} /> {item.label}</Link>
                                            }
                                        </li>
                                    })}
                                </div>
                                }
                            </div>
                        )
                    })

                }
            </Scrollbar>
        </div>
    )
}

export default Leftbar;